/**
 * @author Iskra Popova
 *
 * SceneViewContainer class.
 * Rescalable container for SceenView oblects.
 */

import App from "../App";
import { IObjectConfig } from "../baseConfigs/layoutConfigShema";
import GameModel from '../model/GameModel';
import Layout from "../utils/Layout";
import Utils from "../utils/Utils";
import { Container, Graphics } from "pixi.js";

export default class SceneViewContainer extends Container {
    protected boundShape: Graphics;
    protected maskShape: Graphics;
    // protected maskCont: Container;
    protected boundsConfig: IObjectConfig;
    protected autoscaleEnabled = true;

    constructor(bounds: IObjectConfig, positions?: IObjectConfig[]) {
        super();
        this.boundsConfig = bounds;
        // this.maskCont = new Container();
        this.boundShape = new Graphics();
        this.boundShape.beginFill(0x000000, 0);
        this.boundShape.drawRect(0, 0, Layout.scalePixels(bounds.width), Layout.scalePixels(bounds.height));
        this.addChild(this.boundShape);
        if (positions?.length > 0 && positions.some(pos => pos.id.includes(bounds.id))) {
            this.addMask(positions)
        } else {
            this.maskShape = new Graphics();
            this.maskShape.beginFill(0x000000,1);
            this.maskShape.drawRect(0, 0, Layout.scalePixels(bounds.width),Layout.scalePixels(bounds.height));
            this.maskShape.endFill();
            this.maskShape.alpha = 0.01;
            this.addChild(this.maskShape);
            this.mask = this.maskShape;
        }

    }

    public changeOrientationMasksParse(bounds: IObjectConfig, positions?: IObjectConfig[]) {
        if (positions?.length > 0 && positions.some(pos => pos.id.includes(bounds.id.split("~")[0]))) {
            this.addMask(positions)
        }
    }

    public addMask(positions: IObjectConfig[]) {
        const masks: IObjectConfig[] = positions.reduce((acc, pos) => {
            if (pos.id.includes("mask")) {
                acc.push(pos)
            }

            return acc
        }, [])

        if (masks.length > 0) {
            this.removeChild(this.maskShape);
            this.maskShape = null;
            this.mask = null;

            this.maskShape = new Graphics();
            this.maskShape.beginFill(0x000000,1);
            let startFromY = GameModel.gameConfig.rowMaskStartY || 0;
            let space = startFromY;
            let rowBorderHeight = GameModel.gameConfig.rowMaskSpacesHeight || 0;
            masks.forEach((ms, index) => {
                if (index = 0) {
                    this.maskShape.drawRect(0, Layout.scalePixels(startFromY), Layout.scalePixels(ms.width),Layout.scalePixels(ms.height));
                } else {
                    this.maskShape.drawRect(0, Layout.scalePixels(space), Layout.scalePixels(ms.width),Layout.scalePixels(ms.height));
                }
                space += (rowBorderHeight + ms.height);
            })
            this.maskShape.endFill();
            this.maskShape.alpha = 0.01;
            this.addChild(this.maskShape);
            this.mask = this.maskShape;
        }
    }

    public dissableAutoScale() {
        this.autoscaleEnabled = false;
    }

    public enableAutoScale() {
        this.autoscaleEnabled = true;
    }

    public getMaskShape() {
        return this.maskShape;
    }

    public cleanup(){
        let toRemove = [];
        this.children.forEach(child =>{
            if(!(child==this.mask || child!=this.boundShape)){
                toRemove.push(child)
            }
        })
        toRemove.forEach(child=>{
            this.removeChild(child);
            child.destroy()
        })
    }
    public disableMask() {
        this.mask = null;
    }

    public enableMask() {
        this.mask = this.maskShape;
    }

    public getBoundShape(): Graphics {
        return this.boundShape;
    }

    public getBoundConfig(): IObjectConfig {
        return Utils.deepClone(this.boundsConfig);
    }

    public changeBound(bounds: IObjectConfig) {
        if (!this.autoscaleEnabled) {
            return;
        }
        this.boundsConfig = bounds;
        this.scale.x = this.scale.y = 1;
        Layout.testSetWidth(this.boundShape, bounds.width, false);
        Layout.testSetHeight(this.boundShape, bounds.height, false);
        // Layout.testSetHeight(this.boundShape, bounds.height/multy,false);
        this.scale.x = this.scale.y = Math.max(this.boundShape.scale.x, this.boundShape.scale.y);
        this.boundShape.scale.x = this.boundShape.scale.y = 1;
        // this.maskShape.scale.x = this.maskShape.scale.x/1 ;
        // this.maskShape.scale.y =  this.maskShape.scale.y/1 ;
        let maskAspectRatio = Math.round((bounds.width / bounds.height + Number.EPSILON) * 100) / 100;
        let containerAspectRatio = Math.round((this.maskShape.width / this.maskShape.height + Number.EPSILON) * 100) / 100;
        let dif = Math.round(Math.abs(maskAspectRatio - containerAspectRatio) * 100) / 100;
        // if (dif > 0.03) {
        // if(maskAspectRatio!=containerAspectRatio) {
        // Layout.testSetWidth(this.maskShape, bounds.width/this.scale.x,false);
        // Layout.testSetHeight(this.maskShape, bounds.height/this.scale.x,false);

        // if(this.maskShape) {
        this.maskShape.clear();
        this.maskShape.beginFill(0x000000, 0.01);
        this.maskShape.drawRect(0, 0, Layout.scalePixels(bounds.width) / this.calculateTextMultiplier(), Layout.scalePixels(bounds.height) / this.calculateTextMultiplier());
        this.maskShape.endFill();
        // }
        // }
    }
    public changeSpineAnimBound(bounds: IObjectConfig, setBoundShapeScale = true) {
        if (!this.autoscaleEnabled) {
            return;
        }
        this.boundsConfig = bounds;
        this.scale.x = this.scale.y = 1;
        Layout.testSetWidth(this.boundShape, bounds.width, false);
        Layout.testSetHeight(this.boundShape, bounds.height, false);
        if (setBoundShapeScale) {
            this.scale.x = this.scale.y = Math.max(this.boundShape.scale.x, this.boundShape.scale.y);
        }
        this.boundShape.scale.x = this.boundShape.scale.y = 1;

        this.maskShape.clear();
        this.maskShape.beginFill(0x000000, 0.01);
        this.maskShape.drawRect(0, 0, Layout.scalePixels(bounds.width) / this.calculateTextMultiplier(), Layout.scalePixels(bounds.height) / this.calculateTextMultiplier());
        this.maskShape.endFill();
    }

    protected calculateTextMultiplier(): number {
        return this.scale.x;
    }


}
